// no itx for this file

import { actorActions, actorActionsSensitiv } from "../KnxMappings/Actor/Actions";
import { actorStatus, actorStatusSensitiv } from "../KnxMappings/Actor/Status";
import { NameListEntry } from "../KnxMappings/NameEntryList";
import Logger from "../Logger";
import { isDevelopmentEnvironment } from "../estada-config";
import { ChannelType, DeviceType } from "../models/ChannelType";
import Device from "../models/Device";
import Signal from "../models/Signal";
import SignalType from "../models/SignalType";
import SignalTypes from "../models/SignalTypes";
import { LINK_CHAR } from "../models/Constants";
import { getSignalTypeBundle } from "../models/SignalBundles";

///////////////////////////////////////////////////////////////////////////

//
// retuns true,
// if any item of array "arr" is part of the string "m"
//

const logger = new Logger("determineActorComObjectFunction");

export function matchN(arr: Array<string | RegExp> | undefined, matchString: string): boolean {
  if (matchString == undefined) {
    logger.error("matchString undefined");
    return true;
  }

  matchString = matchString.toLowerCase();

  if (arr) {
    var isMatching = false;
    arr.forEach((item) => {
      if (typeof item === "string") {
        if (matchString.indexOf(item) >= 0) {
          isMatching = true;
        }
      } else {
        // item is a RegExp
        if (item.test(matchString)) {
          isMatching = true;
        }
      }
    });

    return isMatching;
  } else {
    return true;
  }
}

export function equalDPT(arr: Array<string> | undefined, matchString: string): boolean {
  if (matchString == undefined) {
    logger.error("matchString undefined");
    return true;
  }

  matchString = matchString.toLowerCase();

  if (arr) {
    var isMatching = false;
    arr.forEach((item) => {
      if (matchString == item) {
        isMatching = true;
      } else if (matchString.startsWith(item)) {
        //
        // match dpt-9-1 with dpt-9 as wildcard match for all dpt-9`s
        // BUT DONT match dpt-1 with dpt-11-xxx/dpt-1-1 with dpt-1-11
        //
        if (matchString.substring(item.length, item.length + 1) == "-") isMatching = true;
      }
    });

    return isMatching;
  } else {
    return true;
  }
}

export function determineSignalType(
  signal: Signal,
  nameList: Array<NameListEntry>,
  channelType: ChannelType | undefined,
): { signalType: SignalType; id?: string } {
  const functionText = signal.knxFunctionTextEN.toLowerCase();
  var datapointType = signal.knxDatapointType.toLowerCase();

  const manufacturerId = (signal.parent?.parent as Device)?.template?.knxProductData.productInfo.ManufacturerId || "";

  // const name = signal.knxName.toLocaleLowerCase();
  let knxTextEN =
    signal.knxTextENForDetectionRaw?.toLocaleLowerCase() ||
    signal.knxTextENForDetection?.toLocaleLowerCase() ||
    signal.knxTextEN;

  if (knxTextEN.indexOf("central") >= 0) {
    return { signalType: SignalTypes.Ignored, id: "central-1" };
  }

  const idx1 = knxTextEN.indexOf(LINK_CHAR);
  if (idx1 >= 0) {
    // remove linked part from function text
    knxTextEN = knxTextEN.substring(0, idx1).trim();
  }

  let signalBundleForChannelType: Array<SignalType> | undefined;
  let signalBundleEnvironment: Array<SignalType> | undefined;

  if (channelType) {
    //
    // MWE 25.3.2026
    // wenn wir einen channelType vorgegeben haben,
    // dann prüfen wir, ob der SignalType im SignalBundle des channelTypes enthalten ist
    //
    // wenn nein ignorieren wir den match und suchen weiter
    //
    signalBundleForChannelType = getSignalTypeBundle(channelType);
    signalBundleEnvironment = getSignalTypeBundle(ChannelType.Environment);
  }

  for (let i in nameList) {
    const entry = nameList[i];

    const b1 = entry.channelType == undefined || entry.channelType.includes(channelType || ChannelType.Unknown);

    const b2 = (signal as any).a
      ? !entry.objectSize || entry.objectSize == (signal as any).a.ObjectSize?.toLowerCase()
      : !entry.objectSize;

    const b3 = matchN(entry.texts, knxTextEN);

    const b4 = matchN(entry.functionNames, functionText);

    const b5 = equalDPT(entry.dpts, datapointType);

    const b6 = entry.excludeTexts == undefined || !matchN(entry.excludeTexts, knxTextEN);

    const b7 = entry.excludeFunctionNames == undefined || !matchN(entry.excludeFunctionNames, functionText);

    const b8 = entry.manufacturers == undefined || matchN(entry.manufacturers, manufacturerId);
    let b9 = true;
    if (entry.oldSignalType) {
      b9 = entry.oldSignalType == signal.type;
    }
    const match = b1 && b2 && b3 && b4 && b5 && b6 && b7 && b8 && b9;

    let channelTypeMissmatch = false;

    if (channelType) {
      //
      // MWE 25.3.2026
      // wenn wir einen channelType vorgegeben haben,
      // dann prüfen wir, ob der SignalType im SignalBundle des channelTypes enthalten ist
      //
      // wenn nein ignorieren wir den match und suchen weiter
      //
      if (
        signalBundleForChannelType?.includes(entry.signalType) ||
        signalBundleEnvironment?.includes(entry.signalType)
      ) {
        // ok
      } else {
        channelTypeMissmatch = true;
      }
    }

    if (isDevelopmentEnvironment()) {
      const d1 = signal.number == state.debugData?.signalNumberToAnalyse; //  || !state.debugData?.signalNumberToAnalyse;
      const d2 =
        state.debugData?.signalRuleIdToAnalyse &&
        entry.id &&
        entry.id.toLocaleLowerCase().indexOf(state.debugData?.signalRuleIdToAnalyse.toLocaleLowerCase()) >= 0; // !state.debugData?.signalRuleIdToAnalyse ||

      const d0 = state.debugData?.signalNumberToAnalyse || state.debugData?.signalRuleIdToAnalyse;

      if (signal.number == state.debugData?.signalNumberToAnalyse && match) {
        state.debugOutput?.output(`Signal ${signal.number}) rule ${entry.id}: MATCH`, entry);
      }

      if (d1 && d2 && !match) {
        let s = "";
        if (!b1) s += " channelType";
        if (!b2) s += " objectSize";
        if (!b3) s += " texts";
        if (!b4) s += " functionNames";
        if (!b5) s += " dpts";
        if (!b6) s += " excludeTexts";
        if (!b7) s += " excludeFunctionNames";
        if (!b8) s += " manufacturers";
        if (channelTypeMissmatch) s += " channelTypeMissmatch: " + channelType;

        state.debugOutput?.output(
          `Signal (${signal.number}) no match:\n` + `  text: ${knxTextEN}\n`,
          `  function: ${functionText}\n`,
          `  no matching: ${s}\n`,
          { ...entry },
        );
      }
    }

    if (match) {
      const res = { signalType: entry.signalType, id: entry.id };

      if (channelType) {
        //
        // MWE 25.3.2026
        // wenn wir einen channelType vorgegeben haben,
        // dann prüfen wir, ob der SignalType im SignalBundle des channelTypes enthalten ist
        //
        // wenn nein ignorieren wir den match und suchen weiter
        //
        if (channelTypeMissmatch) {
          console.log(`determineSignalType ignore match (by channeltype) (${signal.number}): res=UNKOWN`, res);
        } else {
          return res;
        }
      } else if (res) {
        return res;
      }
    }
  }

  if (!channelType) {
    //
    // wir laufen NICHT für KontextSensitive Signale durch die Regeln..
    // und wenn wir dann keinen SignalType matchen,
    // dann geben wir hier das signal zur analyse aus.
    //
    logger.log(`determineSignalType (${signal.number}): res=UNKOWN`, signal.a);
  }

  return { signalType: SignalTypes.Unknown };
}

const stateNames = ["state", "status", "feedback", "rückmeldung"];
const hybridNames = ["value/status", "switch/status"]; // corresponding to signle signal object for both input and output

export default function determineActorComObjectFunction(
  signal: Signal,
  channelType?: ChannelType | undefined,
  actorDeviceType?: DeviceType,
) {
  var actorStatusList = actorStatus;
  var actorActionsList = actorActions;
  if (channelType) {
    actorStatusList = actorStatusSensitiv;
    actorActionsList = actorActionsSensitiv;
  }

  if (!channelType && actorDeviceType) {
    channelType = actorDeviceType as any as ChannelType;
  }

  let functionText = signal.knxFunctionTextEN.toLowerCase();
  let text = signal.knxTextENForDetection?.toLowerCase() || signal.knxTextEN.toLowerCase();

  const idx1 = text.indexOf(LINK_CHAR);
  if (idx1 >= 0) {
    // remove linked part from function text
    text = text.substring(0, idx1).trim();
  }

  let isStateFunction =
    //signal.a.WriteFlag == "Disabled" ||
    matchN(stateNames, functionText) && !matchN(hybridNames, functionText); // considers hybrid signals as the corresponding action.
  if (matchN(stateNames, text) && !matchN(hybridNames, text)) {
    isStateFunction = true;
  }
  if (!isStateFunction) {
    // is signal  is "writeable" == "a command"
    var actionFunction = determineSignalType(signal, actorActionsList, channelType);
    if (actionFunction.signalType == SignalTypes.Unknown) {
      actionFunction = determineSignalType(signal, actorStatusList, channelType);
    }
    signal.type = actionFunction.signalType;
    if (actionFunction.id) {
      signal.determinedFromId = actionFunction.id;
    }
  } else {
    // signal is a status signal
    const statusFunction = determineSignalType(signal, actorStatusList, channelType);
    signal.type = statusFunction.signalType;
    if (statusFunction.id) {
      signal.determinedFromId = statusFunction.id;
    }
  }
}

// function extendRulesWithBytes() {
//   const allRules = allRuleArraysInOne;

//   function getBitsOfRule(ruleName: string | undefined, dpts: Array<string>): number {
//     let res = new Set<number>();

//     dpts.forEach((dpt) => {
//       const bits = SignalType.getBitsizeOfDpts(dpt);
//       if (bits > 0) {
//         res.add(bits);
//       }
//     });
//     if (res.size > 1) {
//       console.error("more different possible bit sizes " + ruleName + " " + [...res]);
//     }
//     if (res.size == 1) {
//       return [...res][0];
//     }
//     return -1;
//   }
//   function getStringOfBitDpts(bit: number): Array<string> {
//     const res = new Array<string>();
//     if (bit > 0) {
//       res.push(`@ ${bit} bit`);
//       res.push(`@ ${bit} bits`);
//       if (bit % 8 == 0) {
//         const byte = bit / 8;
//         res.push(`@ ${byte} byte`);
//         res.push(`@ ${byte} bytes`);
//       }
//     }
//     return res;
//   }

//   allRules.forEach((rule) => {
//     if (
//       rule.dpts &&
//       (rule.functionNames || rule.texts) &&
//       rule.signalType != SignalTypes.Ignored &&
//       rule.signalType != SignalTypes.Unknown
//     ) {
//       const bit = getBitsOfRule(rule.id, rule.dpts);
//       const bitStrings = getStringOfBitDpts(bit);
//       bitStrings.forEach((bs) => {
//         rule.dpts?.push(bs);
//       });
//     }
//   });
// }

//extendRulesWithBytes();
